<template>

  <modal id="detalhes-notificacao" class="modal-detalhes-notificacao" :titulo="titulo" :loading="loading">

    <template v-if="notificacao">
      <div id="aba-dados-principais" v-if="notificacao">

        <card>
          <div class="row gutters-xs oficio">
            <v-input v-if="config.notificacao.diferenciarPorAtribuicao && !notificacao.id"
                     type="v-select" :options="options.atribuicao" label="Tipo" class="col-2"
                     v-model="notificacao.atribuicao" />
            <v-input type="v-select" :options="options.tiposServico" label="Tipo de Notificação" class="col"
                     v-model="notificacao.tipoServico.id" />
          </div>
        </card>

      </div>
    </template>

    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-auto">Cancelar</button>
      <v-button :run="salvar" class="btn-outline-primary">Salvar</v-button>
    </template>

  </modal>

</template>

<script setup>

import Modal from "@/components/Modal.vue";
import Card from "@/components/Layout/components/Card.vue";
import {computed, getCurrentInstance, onMounted, ref} from "vue";
import NotificacaoBusiness from "@/business/notificacao/NotificacaoBusiness";
import TipoServicoBusiness from "@/business/crud/TipoServicoBusiness";
import FrontBusiness from "@/business/FrontBusiness";
import Utils from "@/commons/Utils";

const props = defineProps({
  anterior: Object,
  matriculas: Array,
  registrosTds: Array,
  envolvidos: Array,
  id: String,
  protocolo: String,
  targetBlank: Boolean,
  reloadPage: {type : Boolean, default: () => true},
});

const notificacao = ref(null);
const tipoServico = ref(null);
const options = ref({ tiposServico: [], atribuicao: [] });

const loading = ref(false);
const setLoading = (value) => {
  loading.value = value;
}

const titulo = computed(() => {
  return props.id ? 'Editar Notificação' : 'Cadastrar Notificação'
})

const close = (retorno) => {
  FrontBusiness.closeModal(retorno)
}

const showError = (e) => {
  FrontBusiness.fullErrorHandler(proxy, e, '#formulario-notificacao')
}

const salvar = async () => {
  if (!notificacao.value.tipoServico?.id) return null;

  const dto = Utils.clone(notificacao.value);

  if (props.protocolo) dto.protocolos.push(props.protocolo);

  dto.protocolos = dto.protocolos?.filter(e => e).map(e => e.id || e);
  if (props.envolvidos?.length) {
    dto.envolvidos = props.envolvidos;
  }
  if (dto.matriculas?.length) {
    dto.matriculas = dto.matriculas.map(m => m.id || m);
  }
  if (dto.registrosTds?.length) {
    dto.registrosTds = dto.registrosTds.map(r => r.id || r)
  }

  const retorno = await NotificacaoBusiness.save(dto, notificacao.value.id).catch(showError)

  if (retorno) {
    if (props.reloadPage) FrontBusiness.redirect(`notificacao/${retorno}/geral`, props.targetBlank)
    close(retorno)
  }
}

const { proxy } = getCurrentInstance();
const config = proxy.$root.config;

onMounted(async () => {
  setLoading(true);

  const config = proxy.$root.config
  if (config.notificacao.diferenciarPorAtribuicao) {
    if (config.atribuicaoRi) {
      options.value.atribuicao.push({ id: 'RI', nome: 'RI' })
    }

    if (config.atribuicaoRtd) {
      options.value.atribuicao.push({ id: 'RTD', nome: 'RTD' })
    }

    if (config.atribuicaoRcpj) {
      options.value.atribuicao.push({ id: 'RCPJ', nome: 'RCPJ' })
    }
  }


  if (props.id) {
    notificacao.value = await NotificacaoBusiness.getById(props.id);
    tipoServico.value = notificacao.value.tipoServico;
  } else {
    notificacao.value = {
      envolvidos: [],
      indices: {},
      tipoServico: {},
      texto: '',
      protocolos: [],
      atribuicao: options.value.atribuicao?.[0]?.id,
    }
  }

  const idsTipoServico = [...new Set([notificacao.value?.tipoServico?.id])].filter(el => el != null)
  const tipos = await TipoServicoBusiness.getByDominioSimplesIds('NOTIFICACAO', idsTipoServico)
  options.value.tiposServico = tipos;

  notificacao.value.tipoServico = notificacao.value.tipoServico || {}

  setLoading(false);
})

</script>

<script>
export default {
  modal: {
    width: 800,
    escapable: false
  }
}
</script>

<style>
  #detalhes-notificacao .modal-body{
    overflow: unset;
  }
</style>
